import React from "react";
import ProductList from "../ProductList";
import ActionRowLoader from "components/ActionRowLoader";
import ProductRowLoaders from "components/ProductRowLoaders";
import { ProductContextProvider } from "utils/context/product";
import pick from "lodash/pick";
import { HUB_DASHBOARD_CLASSES, NAV_BAR_HEIGHT } from "utils/constants/ui";
import PresentLayout from "components/PresentLayout";

const ProductsDashboardHub = ({ customClasses, loading }) => {
  const classes = { ...HUB_DASHBOARD_CLASSES, ...customClasses };

  let content;
  let action;
  if (loading) {
    content = (
      <div className="pa3">
        <ProductRowLoaders count={10} />;
      </div>
    );

    action = <ActionRowLoader />;
  } else {
    action = null;
    content = <ProductList />;
  }

  return (
    <PresentLayout
      header={action}
      content={content}
      mobileTop={NAV_BAR_HEIGHT}
      customClasses={{ ...pick(classes, ["container", "header"]), content: "" }}
    />
  );
};

const ProductsDashboardContainer = ({ loading }) => (
  <ProductContextProvider>
    <ProductsDashboardHub loading={loading} />
  </ProductContextProvider>
);

export default ProductsDashboardContainer;
